export default {
  manage_crew: "Tripulación",
  manage_crew_crewMembers: "Miembros de Tripulación",
  manage_crew_units: "Vehículos",
  manage_crew_crews_name: "Nombre",
  manage_crew_crews_reAssign: "Re-Asignar",
  manage_crew_units_crewAssigned: "Tripulación Asignada",
  manage_crew_units_label: "Vehículo",
  manage_crew_units_assignCrew: "Asignar Tripulación",
  manage_crew_units_editCrew: "Editar Tripulación",
  manage_crew_crews_assignedTo: "Asignar a",
  manage_crews_unitsExported: "La exportación ha sido generada correctamente.",
  manage_crews_search_name_assignedTo: "Buscar por Nombre o Asignado A",
};
